<template>
  <widget class="bg-secondary text-white" edge
      img="data:image/svg+xml;utf8;base64,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"
      name="zakat-calc" title="Zakat Calculator" collapsable collapse>
    <div class="bg-white p-4 text-dark">
    <div class="row">
      <div class="col">
        <fieldset>
          <legend class="h5">Your Assets (Annual)</legend>
          <div v-for="field in assets" :key="field.name" class="form-group row mb-1">
            <label :for="field.name" class="col-sm-6 col-form-label col-form-label-sm">
              {{ field.label }} <i v-if="field.tooltip" data-toggle="tooltip" data-placement="bottom" :title="field.tooltip" class="far fa-question-circle"></i>
            </label>
            <div class="col-sm-6"><input type="number" class="form-control form-control-sm" :name="field.name" v-model="field.value" @click="onFieldClick"></div>
          </div>
          <div class="form-group row border-top pt-1">
            <label class="col-sm-6 col-form-label col-form-label-sm font-weight-bold">1. Total Assets</label>
            <div class="col-sm-6"><input type="number" class="form-control form-control-sm" :value="totalAssets | money" disabled></div>
          </div>
        </fieldset>
      </div>
      <div class="col">
        <legend class="h5">Your Liabilities (Annual)</legend>
        <div v-for="field in liabilities" :key="field.name" class="form-group row mb-1">
          <label :for="field.name" class="col-sm-6 col-form-label col-form-label-sm">{{ field.label }}</label>
          <div class="col-sm-6"><input type="number" class="form-control form-control-sm" :name="field.name" v-model="field.value" @click="onFieldClick"></div>
        </div>

        <div class="form-group row border-top pt-1">
          <label class="col-sm-6 col-form-label col-form-label-sm font-weight-bold">2. Total Liabilities</label>
          <div class="col-sm-6"><input type="number" class="form-control form-control-sm" :value="totalLiabilities | money" disabled></div>
        </div>
        <div class="form-group row mt-3 pt-1">
          <label class="col-sm-6 col-form-label col-form-label-sm font-weight-bold">
            3. Nisab 
          </label>
          <div class="col-sm-6">
            <input type="number" class="form-control form-control-sm" v-model="nisabAmount">
            <div class="form-text text-muted">Nisab is 612 silver grams x price/gram</div>
          </div>
        </div>
        <div class="form-group row mt-3 pt-1">
          <label class="col-sm-6 col-form-label col-form-label-sm font-weight-bold text-success">4. Net Zakatable Assets</label>
          <div class="col-sm-6">
            <input type="number" class="form-control form-control-sm" disabled :value="totalNet | money">
            <div class="form-text text-muted">Total Asset - Total Liabilities.</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group row alert alert-success">
          <label class="col-sm-3 col-form-label col-form-label-sm h5 p-0 m-0">Your Zakat Payment</label>
          <div class="col-sm-9">
            <div class="h4 p-0 m-0">{{ totalZakat | money }}</div>
            <div class="form-text text-muted mt-0">
              2.5% of Total Net assets ({{ totalNet | money }}).<br/> If total Net Zakatable Assets is less than Nisab then no Zakat is due this year.</div>
          </div>
        </div>
      </div>
    </div>
    <p class="mb-0 text-muted"><small>*Information taken from Islamic Relief Zakat handout</small></p>
    </div>
  </widget>
</template>

<script>
import $ from 'jquery';

export default {
  filters: {
    money(val) {
      return val.toFixed(2);
    }
  },

  computed: {
    totalAssets() {
      let total = 0;
      for(let field of this.assets) {
        if(!field.value) continue;
        total += parseInt(field.value);
      }

      return total;
    },

    totalLiabilities() {
      let total = 0;
      for(let field of this.liabilities) {
        if(!field.value) continue;
        total += parseInt(field.value);
      }

      return total;
    },

    totalNet() {
      return Math.max(this.totalAssets - this.totalLiabilities, 0);
    },

    totalZakat() {
      if(this.nisabAmount && this.totalNet < this.nisabAmount) return 0;
      return (this.totalNet/100) * 2.5;
    }
  },

  data() {
    return {
      assets: [
        { name: 'cash', value: '', label: 'Cash (Bank/Others)'},
        { name: 'gold', value: '', label: 'Gold'},
        { name: 'silver', value: '', label: 'Silver'},
        { name: 'business', value: '', label: 'Business Assets',
          tooltip: "According to the % of ownership.  Include cash, wholesale price of goods for sale and inventory and cost of raw materials"
        },
        { name: 'shares', value: '', label: 'Shares',
          tooltip: "If long-term investment without intension to resell, list the dividend income.  Otherwise include their market value."},
        { name: 'retire', value: '', label: 'Retirement Funds (RRSP)',
          tooltip: "List value after deductions are calculated"},
        { name: 'investment', value: '', label: 'Investment Properties',
          tooltip: "For property other than your home for long-term investment without intention to resell - Zakat is due on rental income only.  For property with the prime motivation of capital appreaciation and with the intention to resell in this Zakat year, then please include the value of the property."
        },
        { name: 'others', value: '', label: 'Others'},
      ],

      liabilities: [
        { name: 'rent', value: '', label: 'Rent or Mortgage payments'},
        { name: 'expenses', value: '', label: 'Personal and living expenses'},
        { name: 'bills', value: '', label: 'Utilities/Bills'},
        { name: 'others', value: '', label: 'Others'},
      ],

      nisabAmount: ''
    }
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },

  methods: {
    onFieldClick(el) {
      el.target.select();
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-text {
    font-size: .8em;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/ZakatCalculator.vue